import { useEffect, useState } from "react";

export const useIsPWAInstalled = () => {
  const [isPWA, setIsPWA] = useState(false);

  useEffect(() => {
    const checkPWA = () => {
      const isStandalone = window.matchMedia(
        "(display-mode: standalone)",
      ).matches;
      const isIosStandalone =
        "standalone" in window.navigator && window.navigator.standalone;
      setIsPWA(isStandalone || isIosStandalone);
    };

    checkPWA();
    window.addEventListener("resize", checkPWA); // Optional: in case display mode changes

    return () => {
      window.removeEventListener("resize", checkPWA);
    };
  }, []);

  return isPWA;
};
